<template>
    <j-modal :title="title" :width="1200" :visible="visible" :confirmLoading="confirmLoading" :maskClosable="false" :body-style="{ height: '650px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk" @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
        <a-spin :spinning="confirmLoading">
            <j-form-container :disabled="false">
                <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
                    <a-row :gutter="24">
                        <a-col :span="8">
                            <a-form-model-item :label="$t('路线类型')" prop="routeType">
                                <!-- <a-input v-model="model.routeType" :placeholder="$t('请输入路线类型')" :disabled="disableSubmit"></a-input> -->
                                <j-dict-select-tag v-model="model.routeType" :dictCode="'routeType'" :showSearch="false" :placeholder="$t('请选择路线类型')" :disabled="disableSubmit" />
                                <!-- <a-select :placeholder="$t('请选择路线类型')" v-model="model.routeType">
                  <a-select-option :value="0">{{ $t('管线') }}</a-select-option>
                </a-select> -->
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-model-item :label="$t('路线名称')" prop="routeName">
                                <a-input v-model="model.routeName" :placeholder="$t('请输入路线名称')" :disabled="disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-model-item :label="$t('里程数(Km)')" prop="">
                                <a-input v-model="model.routeMileage" :placeholder="$t('请输入里程数(Km)')" :disabled="disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-model-item :label="$t('备注')" prop="remark">
                                <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" :disabled="disableSubmit" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="24">
                        <a-col :span="24" style="text-align: right;">
                            <!-- <a-dropdown :trigger="['click']">
                <a-menu slot="overlay" @click="handleDeviceAdd">
                  <a-menu-item :key="item" v-for="item in deviceList">{{item.deviceName}}</a-menu-item>
                </a-menu>
                <a-button type="primary" icon="plus"> 添加设备 <a-icon type="down" /> </a-button>
              </a-dropdown> -->
                            <a-button type="primary" icon="plus" @click="addDevice" :disabled="disableSubmit">{{ $t('添加设备') }}</a-button>
                        </a-col>
                    </a-row>
                    <a-row :gutter="24" class="device-label" v-if="model.inspectionTaskRouteDeviceList.length>0">
                        <a-col :span="4">
                            <a-form-model-item :label="$t('选择设备')"></a-form-model-item>
                        </a-col>
                        <a-col :span="4">
                            <a-form-model-item :label="$t('检测类型')"></a-form-model-item>
                        </a-col>
                        <a-col :span="4">
                            <a-form-model-item :label="$t('检测编号')"></a-form-model-item>
                        </a-col>
                        <a-col :span="5">
                            <a-form-model-item :label="$t('检测实体')"></a-form-model-item>
                        </a-col>
                        <a-col :span="5">
                            <a-form-model-item :label="$t('检测内容')"></a-form-model-item>
                        </a-col>
                        <a-col :span="2">
                            <a-form-model-item :label="$t('操作')"></a-form-model-item>
                        </a-col>
                    </a-row>
                    <div v-for="(item,index) in model.inspectionTaskRouteDeviceList" :key="index" class="device-box">
                        <a-form-model :ref="`form${index}`" :model="item" :rules="validatorRules" slot="detail" :colon="false">
                            <a-row :gutter="24">
                                <a-col :span="4">
                                    <a-form-model-item prop="deviceId">
                                        <a-select show-search option-filter-prop="children" :placeholder="$t('请选择设备')" v-model="item.deviceId" @change="handleDeviceAdd($event,index)" :disabled="disableSubmit">
                                            <a-select-option :value="cld.id" v-for="cld in deviceList" :key="cld.id" :disabled="cld.disabled" :title="cld.deviceName">
                                                <!-- <a-tooltip placement="topLeft">
                                                  <template slot="title" v-if="cld.deviceName.length>9">
                                                    {{cld.deviceName}}
                                                  </template>
                                                </a-tooltip> -->
                                                {{cld.deviceName}}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="4">
                                    <a-form-model-item prop="detectType">
                                        <!-- <a-input v-model="item.detectType" :placeholder="$t('请输入检测类型')" :disabled="disableSubmit"></a-input> -->
                                        <j-dict-select-tag v-model="item.detectType" :dictCode="'detectionType'" :showSearch="false" :placeholder="$t('请选择检测类型')" :disabled="disableSubmit" />
                                        <!-- <a-select :placeholder="$t('请选择检测类型')" v-model="item.detectType">
                      <a-select-option :value="0">{{ $t('设备') }}</a-select-option>
                    </a-select> -->
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="4">
                                    <a-form-model-item prop="detectNum">
                                        <a-input v-model="item.detectNum" :placeholder="$t('请输入检测编号')" :disabled="disableSubmit"></a-input>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="5">
                                    <a-form-model-item prop="detectEntity">
                                        <a-input v-model="item.detectEntity" :placeholder="$t('请输入检测实体')" :disabled="disableSubmit"></a-input>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="5">
                                    <a-form-model-item prop="detectContent">
                                        <a-input v-model="item.detectContent" :placeholder="$t('请输入检测内容')" :disabled="disableSubmit"></a-input>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="2">
                                    <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDeviceDelete(item,index)">
                                        <!-- <a><a-icon type="close-circle" style="font-size: 20px;color: #ff4d4f;" /></a> -->
                                        <a :disabled="disableSubmit">{{ $t('删除') }}</a>
                                    </a-popconfirm>
                                </a-col>
                            </a-row>
                        </a-form-model>
                    </div>
                    <a-row :gutter="24" v-if="model.inspectionTaskRouteDeviceList.length>0">
                        <a-col :span="24">
                            <a-form-model-item :label="$t('路线详情')">
                                <div style="width: 100%;height: 500px;" id="amapDiv">
                                    <baidu-map v-if="visible" :center="center" :zoom="zoom" :style="{height: 500+'px'}" :scroll-wheel-zoom="scrollZoom" NavigationControlType="BMAP_NAVIGATION_CONTROL_LARGE" @ready="mapReady">
                                        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
                                        <!-- 信息窗体 -->
                                        <bm-info-window :position="position" :show="show" @close="infoWindowClose" @open="infoWindowOpen">
                                            <div style="width:300px;display:flex;justify-content: space-between;font-weight: bold;">
                                                <div>
                                                    <div>{{ $t('设备编号：') }}{{mapInfo.deviceNum}}</div>
                                                    <div>{{ $t('设备名称：') }}{{mapInfo.deviceName}}</div>
                                                    <div>{{ $t('设备类型：') }}{{deviceTypeList.find(d=>d.value == mapInfo.deviceType) && deviceTypeList.find(d=>d.value == mapInfo.deviceType).text}}</div>
                                                    <div>{{ $t('设备经度：') }}{{mapInfo.detectLongitude}}</div>
                                                    <div>{{ $t('设备纬度：') }}{{mapInfo.detectLatitude}}</div>
                                                </div>
                                            </div>
                                        </bm-info-window>
                                    </baidu-map>
                                </div>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </a-form-model>
            </j-form-container>
        </a-spin>
    </j-modal>
</template>

<script>
// import {
//   JeecgListMixin
// } from '@/mixins/JeecgListMixin';
import {
    httpAction,
    getAction
} from '@/api/manage'
import {
    validateDuplicateValue
} from '@/utils/util'
import {
    List
} from 'ant-design-vue';
import {
    getDictItemsFromCache
} from '@/api/api.js'
import { includes } from 'xe-utils/methods';
import { set } from 'nprogress';
export default {
    // mixins: [JeecgListMixin],
    name: 'lineModal',
    components: {},
    data() {
        return {
            title: '',
            width: 800,
            visible: false,
            disableSubmit: false,
            confirmLoading: false,
            model: {
                inspectionTaskRouteDeviceList: []
            },
            url: {
                add: "/jeecg-engineering/inspection/inspectionRoute/add",
                edit: "/jeecg-engineering/inspection/inspectionRoute/edit",
                queryById: "/jeecg-engineering/inspection/inspectionRoute/queryById",
                list: "/jeecg-engineering/inspection/inspectionDevice/list",
            },
            deviceList: [],
            // 定义地图数据
            BMap: "",
            map: "",
            center: { lng: 118.904, lat: 31.915 },//中心坐标
            centerPoint: { lng: 118.904, lat: 31.915 },
            zoom: 17, //初始缩放比
            scrollZoom: true,//允许鼠标滚轮缩放
            //折线颜色和标注icon
            colorAndIcon: [
                { lineColor: "#b083fb", icon: require("@/assets/sbdw.png") },
                { lineColor: "#b08xab", icon: require("@/assets/duban.png") },
            ],
            //线路坐标信息
            lineMapList: [],
            //站点坐标信息
            stationMapList: [],
            searchAddresKeywords: '',
            localList: [],
            allLine: {},
            show: false,
            position: {},
            mapInfo: {},
            deviceTypeList: []
        }
    },
    computed: {
        validatorRules() {
            return {
                //   routeType: [{
                //     required: true,
                //     message: '请选择路线类型',
                //     trigger: 'change'
                //   }],
                routeName: [{
                    required: true,
                    message: this.$t('请输入路线名称'),
                    trigger: 'blur'
                }],
                routeMileage: [{
                    required: true,
                    message: this.$t('请输入里程数'),
                    trigger: 'blur'
                }],
                deviceId: [{
                    required: true,
                    message: this.$t('请选择设备'),
                    trigger: 'change'
                }],
                //   detectType: [{
                //     required: true,
                //     message: '请选择检测类型',
                //     trigger: 'change'
                //   }],
                //   detectEntity: [{
                //     required: true,
                //     message: '请输入检测实体',
                //     trigger: 'blur'
                //   }],
                //   detectContent: [{
                //     required: true,
                //     message: '请输入检测内容',
                //     trigger: 'blur'
                //   }],
            }
        }
    },
    created() {
        this.deviceTypeList = getDictItemsFromCache('deviceType');
    },
    mounted() {
        this.getDeviceList();
    },
    watch: {
        'model.inspectionTaskRouteDeviceList': {
            immediate: true,
            deep: true,
            handler(val) {
                setTimeout(() => {
                    this.$nextTick(() => {
                        if (val.length > 0) {
                            if(this.map) this.map.clearOverlays(); // 清除标注和折线
                            this.allLine = [...val];
                            // 添加信息框
                            if(this.map) this.map.addEventListener("click", (e) => {
                                this.mapInfo = val.find(al => al.deviceId == e.cb.Bc.textContent);
                                this.position = {
                                    lng: this.mapInfo && this.mapInfo.detectLongitude,
                                    lat: this.mapInfo && this.mapInfo.detectLatitude,
                                };
                                this.show = true;
                            });
                            this.drawMap();
                        }
                    })
                }, 1000)
            }
        }
    },
    methods: {
        // 关闭窗体
        infoWindowClose() {
            this.show = false
        },
        // 打开窗体
        infoWindowOpen() {
            this.show = true
        },
        drawMap() {
            let that = this;
            let BMap = this.BMap;
            let map = this.map;
            let data = this.allLine; //线路
            let data2 = this.allLine; //站点

            // 这里是数据改变时，地图中心点定位到当前第一条数据的第一个坐标点或者默认的中心坐标
            let point = data.length ? data[0] : this.centerPoint;
            this.center = { lng: point.detectLongitude, lat: point.detectLatitude };
            this.zoom = 17;
            this.map.centerAndZoom(this.center, 14);

            // 线路坐标信息 数据类型：数组包数组
            let points = [];

            data.map((item, i) => {
                if (item.deviceId) {
                    points.push(new BMap.Point(item.detectLongitude, item.detectLatitude));
                    this.addPolyline(BMap, map, data, points, i);//调用添加折线方法
                }
            });
            // 站点坐标信息 数据类型：数组包对象
            // for (let i = 0; i < data2.length; i++) {
            //   let points = [];
            //   points.push(new BMap.Point(data2[i].detectLongitude, data2[i].detectLatitude));
            //   this.addStation(BMap, map, data2, points, i);//调用添加站点方法
            // }

            // // 两个设备之间的驾车路线
            // var longpatStr = '';
            // var driving = new BMap.DrivingRoute(map,{
            //   onSearchComplete: function(result){
            //     if(driving.getStatus() == BMAP_STATUS_SUCCESS){
            //       var pts = driving.getResults().getPlan(0).getRoute(0).getPath();
            //       var paths = pts.length;
            //       for (var i = 0; i < paths; i++) {
            //       	console.log(pts[i].lng + " " + pts[i].lat); 
            //       	longpatStr += parseFloat(pts[i].lat) + "|" + parseFloat(pts[i].lng) + ","
            //       }
            //       that.line(longpatStr)
            //     }
            //   }
            // },{
            //   renderOptions: {
            //     map: map,
            //     autoViewport: true
            //   }
            // })
            // for(let i=0;i<data.length;i++){
            //   if(data[i].deviceId){
            //     driving.search(new BMap.Point(data[i].detectLongitude, data[i].detectLatitude),new BMap.Point(data[i+1].detectLongitude, data[i+1].detectLatitude));
            //   }
            // }
            // 两个设备之间的步行路线
            var transit = new BMap.WalkingRoute(map, {
                onSearchComplete: function (result) {
                    if (transit.getStatus() == BMAP_STATUS_SUCCESS) {
                        var pts = transit.getResults().getPlan(0).getRoute(0).getPath();
                        that.map.addOverlay(new BMap.Polyline(pts, { strokeColor: "blue", strokeWeight: 3, strokeOpacity: 1 }));
                    }
                }
            }, {
                renderOptions: {
                    map: map,
                }
            })
            for (let i = 0; i < data.length; i++) {
                if (data[i].deviceId) {
                    transit.search(new BMap.Point(data[i].detectLongitude, data[i].detectLatitude), new BMap.Point(data[i + 1] && data[i + 1].detectLongitude, data[i + 1] && data[i + 1].detectLatitude));
                }
            }

        },
        line(lonlat) {
            var co = lonlat.split(",");
            var pointAttr = new Array();
            for (var i = 0; i < co.length - 1; i++) {
                var loglats = co[i].split("|")
                var point = new BMap.Point(loglats[1], loglats[0])
                pointAttr.push(point);
            }
            var polyline = new BMap.Polyline(pointAttr, {
                strokeColor: "#cc0000",
                strokeWeight: 3,
                strokeOpacity: 1
            });

            this.map.addOverlay(polyline);

            var loglats = co[0].split("|")
            this.map.centerAndZoom(new BMap.Point(loglats[1], loglats[0]), 15);
        },
        //--------地图
        //地图默认方法
        mapReady({ BMap, map }) {
            this.BMap = BMap;
            this.map = map;
            // 回显定位
            // var coordinate = {
            //   lng:this.allLine[0].detectLongitude,
            //   lat:this.allLine[0].detectLatitude
            // };
            // this.center = coordinate;
            // 新增时获取当前定位
            if (!this.model.id) {
                let geolocation = new BMap.Geolocation();
                geolocation.getCurrentPosition(function (r) {
                    if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                        this.center = r.point;
                        // let mk = new BMap.Marker(r.point);
                        // map.addOverlay(mk);
                        map.panTo(r.point);
                        console.log('当前位置：', r.point);
                    } else {
                        console.log('定位失败');
                    }
                }, { enableHighAccuracy: true })
            }
            // var marker = new BMap.Marker(coordinate); // 创建标注
            // map.addOverlay(marker); // 将标注添加到地图中

            // this.drawMap();//适当地方调用

            // 点击地图添加监听事件获取经纬度
            map.addEventListener("click", (e) => {
                // console.log(e.point.lng, e.point.lat);
            });

            //给地图添加鼠标移动事件
            map.addEventListener("mousemove", (e) => {
                //......
            });
        },
        //添加折线
        addPolyline(BMap, map, data, points, index) {
            let _this = this; //注意this的使用
            let polyline = "";
            // 创建折线
            polyline = new BMap.Polyline(points, {
                enableEditing: false, // 是否启用线编辑，默认为false
                // 设置折线颜色,可以设置不同颜色线路，需要自己定义
                strokeColor: this.colorAndIcon[0].lineColor,
                strokeWeight: 5, // 折线宽度
                strokeOpacity: 1, // 折线透明度
            });
            // map.addOverlay(polyline); // 将折线添加到地图
            //折线点击事件
            polyline.addEventListener("click", function (e) {
                //......
            });
            for (let j = 0; j < points.length; j++) {
                this.addMarker(
                    BMap,
                    map,
                    new BMap.Point(data[j].detectLongitude, data[j].detectLatitude),
                    data[j],
                    index
                );
            }
        },
        //添加icon和标识
        addMarker(BMap, map, point, number, index) {
            let marker = "";//线体坐标点
            let label = "";//icon上的文字
            let myIcon = new BMap.Icon(
                //也可以设置不同坐标点上的icon，需要自己定义
                this.colorAndIcon[0].icon,
                new BMap.Size(30, 30), //图标可视区域大小
                { anchor: new BMap.Size(8, 8) } //图标定位点相对于图标左上角的偏移量
            );
            myIcon.setImageSize(new BMap.Size(25, 25)); // 设置icon大小
            marker = new BMap.Marker(point, { icon: myIcon }); // 创建图像标注
            map.addOverlay(marker); // 将标注添加到地图
            //icon标识内容位置
            label = new BMap.Label(number.deviceId, { offset: new BMap.Size(3, 0) });
            // 文本标识样式
            label.setStyle({
                // fontWeight: 600,
                fontSize: "14px",
                color: "black",
                backgroundColor: "#fff",
                border: '1px solid #000',
                display: 'none'
            });
            marker.setLabel(label); // 为icon添加文本标识
        },
        //站点数据处理  逻辑同上
        addStation(BMap, map, data, points, index) {
            for (let j = 0; j < points.length; j++) {
                this.addStationMarker(
                    BMap,
                    map,
                    new BMap.Point(data[index].detectLongitude, data[index].ladetectLatitudet),
                    j + 1,
                    index
                );
            }
        },
        //添加站点标注
        addStationMarker(BMap, map, point, number, index) {
            let marker = "";
            let myIcon = new BMap.Icon(
                this.colorAndIcon[1].icon,
                new BMap.Size(30, 30),
                { anchor: new BMap.Size(8, 8) }
            );
            myIcon.setImageSize(new BMap.Size(18, 18));
            marker = new BMap.Marker(point, { icon: myIcon });
            map.addOverlay(marker);
        },
        getDeviceList(list) {
            this.deviceList = [];
            getAction(this.url.list, { pageSize: 999, order: 'desc', column: 'createTime' }).then(res => {
                if (res.success) {
                    res.result.records && res.result.records.forEach(item => {
                        this.deviceList.push({
                            id: item.id,
                            deviceType: item.deviceType,
                            deviceNum: item.deviceNum,
                            deviceName: item.deviceName,
                            detectLongitude: item.detectLongitude,
                            detectLatitude: item.detectLatitude,
                            deviceDetail: item.deviceDetail,
                            remark: item.remark,
                            disabled: false
                        });
                    })
                    if(list&&list.length>0){
                        list.forEach(item => {
                            this.deviceList.forEach(item1 => {
                                if (item.deviceId == item1.id) {
                                    item1.disabled = true;
                                }
                            })
                        });
                    }
                }
            })
        },
        add() {
            this.visible = true;
            this.getDeviceList();
            this.model = {
                inspectionTaskRouteDeviceList: []
            };
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        edit(record) {
            this.visible = true;
            // getAction(this.url.queryById, { id: record.id }).then(res => {
            //     if (res.success) {
            //         this.model = res.result;
            //         if (!this.model.inspectionTaskRouteDeviceList) {
            //             this.$set(this.model, 'inspectionTaskRouteDeviceList', []);
            //         }
            //         this.getDeviceList(this.model.inspectionTaskRouteDeviceList);
            //     }
            // });
            this.model = Object.assign({}, record);
            if (!this.model.inspectionTaskRouteDeviceList) {
                this.$set(this.model, 'inspectionTaskRouteDeviceList', []);
            }
            this.getDeviceList(this.model.inspectionTaskRouteDeviceList);
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        close() {
            this.$emit('close');
            this.visible = false;
        },
        handleOk() {
            const that = this;
            // 触发表单验证
            let formItemValid = [];
            this.model.inspectionTaskRouteDeviceList.forEach((dev, index) => {
                let ref = 'form' + index;
                that.$refs[ref][0].validate(valid => {
                    if (valid) {
                        formItemValid.push(true);
                    } else {
                        formItemValid.push(false);
                    }
                })
            });
            this.$refs.form.validate(valid => {
                if (valid && !formItemValid.includes(false)) {
                    that.confirmLoading = true;
                    let httpurl = '';
                    let method = '';
                    if (!this.model.id) {
                        httpurl += this.url.add;
                        method = 'post';
                    } else {
                        httpurl += this.url.edit;
                        method = 'put';
                    }
                    httpAction(httpurl, this.model, method).then((res) => {
                        if (res.success) {
                            that.$message.success(res.message);
                            that.$emit('ok',that.model.id?true:false);
                            this.visible = false;
                        } else {
                            that.$message.warning(res.message);
                        }
                    }).finally(() => {
                        that.confirmLoading = false;
                    })
                }

            })
        },
        handleCancel() {
            this.close()
        },
        handleDeviceAdd(e, index) {
            let deviceInfo = this.deviceList.find(item => item.id == e);
            this.$set(this.model.inspectionTaskRouteDeviceList, index, {
                deviceId: deviceInfo.id,
                deviceNum: deviceInfo.deviceNum,
                deviceName: deviceInfo.deviceName,
                detectLongitude: deviceInfo.detectLongitude,
                detectLatitude: deviceInfo.detectLatitude,
                deviceDetail: deviceInfo.deviceDetail,
                deviceType: deviceInfo.deviceType,
                remark: deviceInfo.remark,
            });
            // 选择后设备置灰
            this.deviceList.forEach(de => de.disabled = false);
            this.deviceList.forEach(de => {
                let index = this.model.inspectionTaskRouteDeviceList.findIndex(it => it.deviceId == de.id);
                if (index > -1) {
                    de.disabled = true;
                }
            });
        },
        handleDeviceDelete(item, index) {
            this.model.inspectionTaskRouteDeviceList.splice(index, 1);
            // 删除后的设备可重新选
            this.deviceList.forEach(de => de.disabled = false);
            this.deviceList.forEach(de => {
                let index = this.model.inspectionTaskRouteDeviceList.findIndex(it => it.deviceId == de.id);
                if (index > -1) {
                    de.disabled = true;
                }
            });
        },
        addDevice() {
            if (this.model.inspectionTaskRouteDeviceList.length == this.deviceList.length) {
                this.$message.warning(this.$t('添加设备超出设备数'));
            } else {

                this.model.inspectionTaskRouteDeviceList.push({});
            }
        }
    }
}
</script>
<style scoped lang="less">
.device-label {
    background-color: #eee;
    margin: 10px 0 0 0 !important;
    padding: 0 8px;
    .ant-form-item {
        margin-bottom: 0;
    }
}
.device-box {
    background-color: #eee;
    padding: 10px 20px;
    margin: 0 0 5px 0;
    .ant-form-item {
        margin-bottom: 0;
    }
    /deep/.ant-col-2 {
        padding-top: 9px;
    }
}
</style>